// Shared by React and the dependency-free build-time renderer. Keep text in one source.
const React = require("react");
const pages = require("./publicPages.json");
const h = React.createElement;

function PublicContent({ page = "home", standalone = false }) {
  const content = pages[page];
  return h(standalone ? "main" : "article", { className: "public-content" },
    standalone && h("h1", null, content.heading),
    content.contents && h("nav", { "aria-label": "가이드 목차" },
      content.contents.map((item) => h("a", { key: item.href, href: item.href }, item.label)),
    ),
    content.sections.map((section) => h("section", { key: section.id, id: section.id },
      h(section.level === 3 ? "h3" : "h2", null, section.heading),
      (section.paragraphs || []).map((paragraph, index) => h("p", { key: index }, paragraph)),
      section.steps && h("ol", null, section.steps.map((step) => h("li", { key: step }, step))),
    )),
    h("nav", { "aria-label": "서비스 안내" },
      h("a", { href: "/" }, "홈"),
      h("a", { href: "/bar-exam" }, "모의고사 목록"),
      h("a", { href: "/guide" }, "이용 가이드"),
      h("a", { href: "/answers/new" }, "주관식 답안 연습"),
    ),
    h("footer", null,
      h("a", { href: "/policy" }, "이용약관"), " · ",
      h("a", { href: "/privacy" }, "개인정보 처리방침"),
      h("p", null, "서비스 문의: ", h("a", { href: "mailto:ibtpracticehelp@gmail.com" }, "ibtpracticehelp@gmail.com")),
    ),
  );
}
module.exports = PublicContent;
